const getBrowserLocale = () =>
  navigator?.languages !== undefined ? navigator?.languages[0] : navigator?.language;

export { getBrowserLocale };